var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sui-progress',{attrs:{"percent":_vm.totalProgress,"success":"","state":"success","progress":"","size":"tiny","attached":"","bottom":"","content":"","indicating":_vm.saving}})
}
var staticRenderFns = []

export { render, staticRenderFns }